<template>
    <div>
        <loading-inside-component v-if="dataLoading && showTitle"></loading-inside-component>
        <v-container fluid :class="removeSpace ? 'pa-0' : ''">
            <page-title
                v-if="showTitle"
                :title="$t(isEdit ? 'updateCampaign' : 'createCampaign') | capitalizeAll"></page-title>
            <v-card class="elevation-1">
                <v-card-text>
                    <div class="campaign-steps">
                        <ul>
                            <template v-for="(step, stepIdx) in stepsArr">
                                <li :key="step.title"
                                    :class="{
                                        active: activeStep === (stepIdx),
                                        valid : step.valid,
                                        disabled: isOutboundCallerOnly()
                                    }"
                                    :disabled="isOutboundCallerOnly()">
                                <span class="step" @click="setStep(stepIdx)">
                                    <b>
                                        <span>{{ stepIdx + 1 }}</span>
                                        <v-icon class="done">mdi-check-bold</v-icon>
                                        <v-icon class="pencil">mdi-pencil-outline</v-icon>
                                    </b>
                                    <span>{{ $t('step.' + step.title) }}</span>
                                </span>
                                </li>
                            </template>
                        </ul>
                    </div>
                    <div class="campaign-form fci-scrollbar">
                        <div v-if="activeStep === 0">
                            <NewCampaignStep1 :next="save" :next-title="nextTitle"></NewCampaignStep1>
                        </div>
                        <div v-if="activeStep === 1 && !useTovaOrVoiceAgent">
                            <NewCampaignStep2
                                :next="save"
                                :next-title="nextTitle"
                                :can-go-back="true"
                                :back="back"></NewCampaignStep2>
                        </div>
                        <div v-if="activeStep === 1 && useTovaOrVoiceAgent">
                            <NewCampaignStep21
                                :next="save"
                                :next-title="nextTitle"
                                :can-go-back="true"
                                :back="back"></NewCampaignStep21>
                        </div>
                        <template v-if="campaign">
                            <div v-if="activeStep === 2 && campaign.direction === 'OUTBOUND'">
                                <NewCampaignStep3
                                    :is-step="true"
                                    :can-next="!isLast"
                                    :next="save"
                                    :next-title="nextTitle"
                                    :can-go-back="true"
                                    :back="back"
                                    :campaign="campaign"></NewCampaignStep3>
                            </div>
                            <div v-if="activeStep === 3 || (activeStep === 2 && campaign.direction === 'INBOUND')">
                                <NewCampaignStep4
                                    :is-step="true"
                                    :next="save"
                                    :next-title="nextTitle"
                                    :back="back"
                                    :can-go-back="true"
                                ></NewCampaignStep4>
                            </div>
                        </template>
                    </div>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>
<script>
import LoadingInsideComponent from '@/components/LoadingInsideComponent'
import PageTitle from '@/components/PageTitle'
import NewCampaignStep1 from './Form/NewCampaignStep1'
import NewCampaignStep2 from './Form/NewCampaignStep2'
import NewCampaignStep3 from './Form/NewCampaignStep3'
import NewCampaignStep4 from './Form/NewCampaignStep4'
import CampaignService from '@/services/campaign.service'
import RoleMixin from '@/modules/fptai/mixins/RoleMixin'
import {mapState} from 'vuex'
import utils from "@/utils/utils";
import NewCampaignStep21 from "@/views/Campaign/Form/NewCampaignStep21.vue";

export default {
    name: 'CampaignForm',
    components: {
        LoadingInsideComponent,
        PageTitle,
        NewCampaignStep1,
        NewCampaignStep2,
        NewCampaignStep3,
        NewCampaignStep4,
        NewCampaignStep21,
    },
    mixins: [RoleMixin],
    props: {
        campaignId: String,
        showTitle: {
            type: Boolean,
            default: true
        },
        removeSpace: {
            type: Boolean,
            default: false
        },
        dontRedirect: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            steps: [],
            inboundSteps: [
                {
                    title: 'campaign',
                    valid: false
                },
                {
                    title: 'callScenarios',
                    valid: false
                }
            ],
            outboundSteps: [
                {
                    title: 'callTo',
                    valid: false
                },
                {
                    title: 'callSetting',
                    valid: false
                }
            ],
            activeStep: 0
        }
    },
    mounted() {
        let id = this.campaignId || this.$route.query.campaignId
        if (id) {
            this.$store.dispatch(this.$actionTypes.campaign.IS_EDIT, true)
            this.$appService.showLoading()
            CampaignService.getCampaign(id).then(res => {
                this.$store.dispatch(this.$actionTypes.campaign.SET_DATA, res.data).then(() => {
                    if (this.isOutboundCallerOnly()) {
                        this.activeStep = 2
                    }
                }).finally(this.$appService.hideLoading)
            }).catch(this.$appService.hideLoading)
        }
        this.steps = [...this.stepsArr]
    },
    computed: {
        utils() {
            return utils
        },
        ...mapState({
            dataLoading: state => state.isDataLoading,
            campaign: state => state.campaign.campaign,
            isEdit: state => state.campaign.isEdit,
            userRoles: state => state.user.profile.roles
        }),
        nextTitle() {
            if (this.isLast) {
                if (this.isEdit) {
                    return this.$f.tc('save')
                } else {
                    return this.$f.tc('done')
                }
            } else {
                return this.$f.tc('next')
            }
        },
        stepsArr() {
            if (this.campaign && this.campaign.direction === 'OUTBOUND') {
                let arr = [...this.outboundSteps]
                if (!this.$utils.canEditCampaign()) {
                    arr.pop()
                }
                return [...this.inboundSteps, ...arr]
            } else {
                let arr = [...this.outboundSteps]
                arr.shift()
                return [...this.inboundSteps, ...arr]
            }
        },
        isFirst() {
            return this.activeStep === 0
        },
        isLast() {
            return this.activeStep + 1 === this.steps.length
        },
        useTovaOrVoiceAgent() {
            return utils.enableTovaAgent() || utils.enableVoiceAgent()
        }
    },
    methods: {
        save(done) {
            this.$emit('change-title', this.campaign.title)
            this.steps.map((step, idx) => {
                if (idx === this.activeStep) {
                    this.$set(step, 'valid', true)
                }
            })
            if (done) {
                if (!this.isEdit) {
                    this.$router.push('/campaign')
                }
                // if (!this.dontRedirect) {
                //     if (this.isEdit) {
                //         this.$router.go(-1)
                //     } else {
                //         this.$router.push('/campaign')
                //     }
                // }
            } else {
                this.next()
            }
        },
        setStep(index) {
            if (this.isOutboundCallerOnly()) {
                this.$appService.toastError('You do not have permission')
                return
            }
            if (this.steps[index].valid || this.isEdit) {
                this.activeStep = index
            }
        },
        next() {
            if (this.isOutboundCallerOnly()) {
                this.$appService.toastError('You do not have permission')
                return
            }
            if (this.activeStep + 1 < this.steps.length) {
                this.activeStep++
            }
        },
        back() {
            if (this.isOutboundCallerOnly()) {
                this.$appService.toastError('You do not have permission')
                return
            }
            if (this.activeStep > 0) {
                this.activeStep--
            }
        },
        isOutboundCallerOnly() {
            if (!this.campaign) {
                return false
            }
            if (this.campaign.direction === "OUTBOUND" && this.campaign.permissions) {
                let permissions = this.$utils.cloneObject(this.campaign.permissions)
                let permissionType = this.$const.campaign.permission
                if (
                    !permissions.includes(permissionType.ADMIN) &&
                    !permissions.includes(permissionType.OWNER) &&
                    permissions.includes(permissionType.OUTBOUND_CALLER)
                ) {
                    return true
                }
            }
            return false
        }
    },
    watch: {
        campaign(value) {
            this.steps = [...this.stepsArr]
        }
    },
    beforeDestroy() {
        this.$store.dispatch(this.$actionTypes.campaign.SET_DATA, false)
        this.$store.dispatch(this.$actionTypes.campaign.IS_EDIT, false)
    }
}
</script>
<style scoped lang="scss">
$primary: #0052CC;
$gray: #919191;
.campaign-steps {
    margin: 0 0 20px;

    li.disabled .step b {
        border-color: rgba(145, 145, 145, 0.1);
        color: rgba(0, 0, 0, 0.1);
        cursor: default;
    }
}

@media screen and (min-width: 768px) {
    .campaign-steps {
        text-align: center;
        position: relative;
        z-index: 1;
        padding-top: 25px;

        ul {
            list-style: none;
            display: block;
            margin: 0;
            padding: 0;
        }

        li {
            display: inline-block;
            vertical-align: top;
            position: relative;
            width: 140px;

            &:after {
                content: '';
                position: absolute;
                left: 50%;
                top: 24px;
                width: 100%;
                height: 2px;
                background: $gray;
                overflow: hidden;
                z-index: 1;
            }

            &:last-child:after {
                display: none;
            }
        }

        .step {
            display: block;
            text-align: center;
            position: relative;
            z-index: 10;

            b {
                display: block;
                margin: 0 auto;
                border: 2px solid $gray;
                background: #fff;
                width: 50px;
                height: 50px;
                line-height: 46px;
                font-size: 24px;
                border-radius: 50%;
                cursor: pointer;
            }

            i {
                display: none;
                line-height: 46px;
            }

            > span {
                font-weight: bold;
                color: $gray;
                font-size: 16px;
                margin: 10px 0 0 0;
                display: block;
            }
        }

        .active,
        .valid {
            .step {
                b {
                    background: $primary;
                    border-color: $primary;
                    color: #fff;
                }

                > span {
                    color: #404040;
                }
            }
        }

        .valid {
            .step {
                b span {
                    display: none;
                }

                b i.done {
                    display: inline-flex;
                    color: #fff;
                }

                > span {
                    color: $primary;
                }
            }
        }
    }
}

@media screen and (max-width: 767px) {
    .campaign-steps {
        text-align: center;

        ul {
            list-style: none;
            margin: 0;
            border-top: 2px solid $gray;
            border-right: 2px solid $gray;
            padding: 0;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
            align-content: center;
        }

        li {
            width: 50%;
            margin: 0;
            color: $gray;
            border-left: 2px solid $gray;
            border-bottom: 2px solid $gray;
            position: relative;
            z-index: 1;
        }

        .step {
            display: block;
            line-height: 50px;
            padding: 0 10px;
            font-size: 18px;
            position: relative;
            z-index: 3;

            b {
                display: none;
            }

            i {
                line-height: 50px;
                display: none;
            }

            > span {
                font-weight: bold;
                display: block;
            }
        }

        .active,
        .valid {
            border-color: $primary;
            background: $primary;
            color: #fff;

            &:before {
                position: absolute;
                content: '';
                width: 100%;
                height: 100%;
                -webkit-box-sizing: content-box;
                -moz-box-sizing: content-box;
                box-sizing: content-box;
                border: 2px solid #00c1dc;
                left: -2px;
                top: -2px;
                z-index: 2;
            }

            .step {
                b {
                    display: inline-block;
                }

                b span {
                    display: none;
                }

                b i {
                    color: #fff;
                    vertical-align: top;
                    margin-right: 16px;
                }

                b i.done {
                    display: inline-block;
                }

                > span {
                    display: inline-block;
                    vertical-align: top
                }
            }
        }

        .active:not(.valid) {
            .step {
                b i.done {
                    display: none;
                }

                b i.pencil {
                    display: inline-block;
                }
            }
        }
    }
}

@media screen and (max-width: 599px) {
    .campaign-steps {
        li {
            width: 100%
        }

        .active .step,
        .valid .step {
            padding-left: 50px;

            b i {
                margin-right: 0;
                width: 50px;
                position: absolute;
                left: 0;
                top: 0;
            }
        }
    }
}

.campaign-form {
    position: relative;
    z-index: 2;
    height: calc(100vh - 363px) !important;
    overflow-y: auto;
}
</style>
<style>
.step-actions {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
}

.step-actions button.v-btn {
    margin: 0 8px;
    width: auto;
    min-width: 120px;
}

@media screen and (max-width: 599px) {
    .step-actions {
        margin: 0;
        text-align: center;
        padding: 10px 0 0;
    }

    .step-actions button.v-btn {
        width: 100%;
        margin: 0 0 16px;
    }
}
</style>
